<template>
	<div>
		<Row :gutter="16" type="flex" justify="center" >
			<Col span="24">
			<Row :gutter="16" type="flex" justify="center" >
				<Col span="6">
				<div class="nbox">
					<img src="../assets/photo/1.jpg"
						style="width:  100%;height: 200px;border-radius: 8px;" />
				</div>
				</Col>
				<Col span="6">
				<div class="nbox">
					<img src="../assets/photo/2.jpg"
						style="width:  100%;height: 200px;border-radius: 8px;" />
				</div>
				</Col>
				<Col span="6">
				<div class="nbox">
					<img src="../assets/photo/3.jpg"
						style="width:  100%;height: 200px;border-radius: 8px;" />
		
				</div>
				</Col>
				<Col span="6">
				<div class="nbox">
					<img src="../assets/photo/4.jpg"
						style="width:  100%;height: 200px;border-radius: 8px;" />
		
				</div>
				</Col>
			</Row>
			<Row :gutter="16" type="flex" justify="center" style="margin-top: 50px;">
				<Col span="6">
				<div class="nbox">
					<img src="../assets/photo/5.jpg"
						style="width:  100%;height: 200px;border-radius: 8px;" />
		
				</div>
				</Col>
				<Col span="6">
				<div class="nbox">
					<img src="../assets/photo/6.jpg"
						style="width: 100%;height: 200px;border-radius: 8px;" />
		
				</div>
				</Col>
				<Col span="6">
				<div class="nbox">
					<img src="../assets/photo/7.jpg"
						style="width: 100%;height: 200px;border-radius: 8px;" />
		
				</div>
				</Col>
				<Col span="6">
				<div class="nbox">
					<img src="../assets/photo/8.jpg"
						style="width: 100%;height: 200px;border-radius: 8px;" />
				</div>
				</Col>
			</Row>
			</Col>
		
		</Row>
	</div>
</template>

<script>
	export default {
		name: 'photos'
	}
</script>

<style>
</style>
